import * as Constants from '../constants/reward';

export const getRewards = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_REWARDS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/rewards/`,
      params,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_REWARDS_SUCCESS, payload: res.data.rewards });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_REWARDS_FAILED, payload: error });
        reject(error);
      });
  });

export const createReward = ($http, ENV, rewardInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_REWARD_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/rewards/`,
      data: rewardInfo,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_REWARD_SUCCESS, payload: res.data.rewards });
        resolve(res.data.rewards);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_REWARD_FAILED, payload: error });
        reject(error);
      });
  });

export const getReward = ($http, ENV, rewardId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_REWARD_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/rewards/${rewardId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_REWARD_SUCCESS, payload: res.data.rewards });
        resolve(res.data.rewards);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_REWARD_FAILED, payload: error });
        reject(error);
      });
  });

export const updateReward = ($http, ENV, rewardId, rewardInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_REWARD_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/rewards/${rewardId}/`,
      data: rewardInfo,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_REWARD_SUCCESS, payload: res.data.rewards });
        resolve(res.data.rewards);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_REWARD_FAILED, payload: error });
        reject(error);
      });
  });

export const clearReward = () => (dispatch) => dispatch({ type: Constants.CLEAR_REWARD });
